import { SHELL, INSET_X, LINE } from '@/components/base/Frame';
import SectionLabel from '@/components/base/SectionLabel';
import { coImplement } from '@/mocks/customerOperations';
import Chapter from './Chapter';

export default function ImplementSection() {
  return (
    <Chapter id="implement">
      <div className={`${SHELL} flex flex-col py-10 md:py-14`}>
        <div className={INSET_X}>
          <SectionLabel index="04" label="What we implement" />
          <h2 className="mt-4 max-w-[22ch] text-3xl font-light leading-[1.1] tracking-[-0.02em] text-foreground-950 lg:text-[clamp(30px,2.9vw,42px)]">
            Designed around the systems you already use.
          </h2>
        </div>

        <ol className={`mt-10 grid grid-cols-1 border-t ${LINE} md:mt-14 md:grid-cols-3`}>
          {coImplement.map((c, i) => (
            <li
              key={c.index}
              className={`group flex flex-col border-b ${LINE} py-8 md:border-b-0 md:py-10 ${i > 0 ? `md:border-l ${LINE}` : ''} ${INSET_X}`}
            >
              <div className="flex items-center gap-3">
                <span className="font-label text-xs tracking-[0.1em] text-primary-500">{c.index}</span>
                <span className="h-px flex-1 bg-primary-200/70 transition-colors duration-500 group-hover:bg-primary-500" />
              </div>
              <h3 className="mt-8 text-xl font-light tracking-[-0.01em] text-foreground-950 md:mt-14 lg:text-2xl">{c.title}</h3>
              <p className="mt-3 max-w-[22rem] text-base font-light leading-relaxed text-foreground-700">{c.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </Chapter>
  );
}